import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { mapDestinationsToCombo } from '../../utils/array-entity-to-combo'
import { DestinationsApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los destinos',
  })
}

const useDestinations = (supplierCode?: number | undefined) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.DESTINATIONS_FILTERED, { supplierCode }],
    () => DestinationsApi.getDestinationsByFilters(supplierCode),
    {
      staleTime: Infinity,
      onError,
    },
  )
  const { data: allDestinations } = useQuery(
    [QUERY_KEYS.DESTINATIONS],
    () => DestinationsApi.getDestinations(),
    {
      staleTime: Infinity,
      onError,
    },
  )

  const destinationsOptions = mapDestinationsToCombo(data)

  const allDestinationsOptions = mapDestinationsToCombo(allDestinations)

  return {
    destinations: data,
    isLoading,
    destinationsOptions,
    allDestinationsOptions,
  }
}

export { useDestinations }
